import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { Modalable } from "@app/Modalable"
import {
	PatientModalComponent,
	TableWrapComponent,
} from "@app/utils/utils.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { PreviewFinresourceComponent } from "@app/preview-finresource/preview-finresource.component"
import { AddDocumentComponent } from "@app/add-document/add-document.component"
import { RequireDefaultSignatureComponent } from "@app/require-fields/RequireCcField.component"

@Component({
	selector: "app-sign-documents",
	imports: [
		COMMON_IMPORTS,
		TableWrapComponent,
		LangValPipe,
		PatientModalComponent,
		DateFormatPipe,
		ModalWrapComponent,
		PreviewFinresourceComponent,
		AddDocumentComponent,
		RequireDefaultSignatureComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./sign-documents.component.html",
})
export class SignDocumentsComponent extends Modalable {
	modalProps: any = null
	isDefaultSigOpen: boolean = true

	data: any = null //will hold the data returning from the api call
	signDocument: any = null
	message: string = ""
	headtures: any[] = []

	async init() {
		const res2: any = await this.apiService.get_gen_items("headtures")
		this.headtures = res2.headtures

		const res: any = await this.apiService.post("get_for_signing_documents")
		this.signDocument = res.documents

		this.store.removeDecArr(this.signDocument)
		this.signDocument.forEach((document) => {
			if (document.patient_id) {
				document.patient_name =
					this.store.searchSiteDataItem(document.patient_id, ["patients"])
						?.name || ""
			}
			if (document.payor_id) {
				document.payor_name =
					this.store.searchSiteDataItem(document.payor_id, ["payors"])?.name ||
					""
			}
			if (document.user_id) {
				document.user_name =
					this.store.searchSiteDataItem(document.user_id, ["sub_users"])
						?.name || ""
			}
		})
	}

	async previewDocument(row: any) {
		if (!row.headture_id) {
			return
		}
		const headtureRow = this.headtures.find((it) => it.id == row.headture_id)
		row.from = headtureRow?.header || ""
		row.headture_id = headtureRow?.id || 0
		row.medical_conf = "yes"
		row.mode = "update"
		if (this.permsService?.owner_has_users) {
			headtureRow.signature_text = row.default_signature
			headtureRow.signature_text_therapist = this.store.cc().default_signature
		}
		this.modalProps = {
			name: "preview-finresource",
			headtureRow,
			finresourceObj: { ...row },
			doctype: "document",
		}
	}

	async editDocument(row: any) {
		row.mode = "update"
		this.modalProps = { name: "add-document", row }
	}
}
